
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

interface HeroBackgroundProps {
  videoUrl: string;
}

const HeroBackground: React.FC<HeroBackgroundProps> = ({ videoUrl }) => {
  const { currentLanguage } = useLanguage();
  
  // Get accessible title based on language
  const getVideoTitle = () => {
    switch (currentLanguage) {
      case 'de': return 'KI Video Marketing Hintergrundvideo';
      case 'en': return 'AI Video Marketing Background Video';
      case 'fr': return 'Vidéo d\'arrière-plan de marketing vidéo IA';
      case 'it': return 'Video di sfondo di marketing video AI';
      default: return 'AI Video Marketing Background Video';
    }
  };
  
  // Get accessible description based on language
  const getVideoDescription = () => {
    switch (currentLanguage) {
      case 'de': return 'Animierter KI-generierter Videohintergrund für Social Media Marketing';
      case 'en': return 'Animated AI-generated video background for social media marketing';
      case 'fr': return 'Arrière-plan vidéo animé généré par IA pour le marketing des médias sociaux';
      case 'it': return 'Sfondo video animato generato dall\'IA per il marketing dei social media';
      default: return 'Animated AI-generated video background for social media marketing';
    }
  };
  
  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden bg-black z-0" aria-hidden="true">
      <div className="absolute inset-0 w-full h-full z-10 bg-gradient-to-b from-black/70 via-black/50 to-[#030307]"></div>
      <iframe 
        src={videoUrl}
        allow="fullscreen;autoplay" 
        allowFullScreen
        style={{ 
          border: 'none', 
          width: '100%', 
          height: '100%', 
          objectFit: 'cover',
          position: 'absolute',
          left: '0px',
          top: '0px',
          overflow: 'hidden' 
        }}
        title={getVideoTitle()}
        aria-label={getVideoDescription()}
        aria-hidden="true"
        loading="lazy"
      ></iframe>
    </div>
  );
};

export default HeroBackground;
